import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ChatCommand } from '../models/event.models';

@Injectable({
    providedIn: 'root'
})
export class ChatEventsService {
    private readonly errorSource: Subject<any> = new Subject<any>();
    error$ = this.errorSource.asObservable();

    constructor(
        public http: HttpClient,
    ) { }

    private readonly chatEvent: Subject<ChatCommand> = new Subject<ChatCommand>();
    public chatEvent$ = this.chatEvent.asObservable();

    /**
     * Broadcasts a chat event to external subscribers.
     * This allows 
     * @param event 
     */
    broadcastEvent(event: ChatCommand) {
        this.chatEvent.next(event);
    }
}